import React, { useState, useEffect, useRef } from "react";

import styleClasses1 from './css/MyPage.module.scss';
import styleClasses2 from './css/mobile/MyPage.module.scss';

const KakaoMapSearch = ({ mobile, onSelect, setOpenPopup, setPopupTitle, setPopupButtonText, setCustomFunction }) => {
  const styleClasses = !mobile ? styleClasses1 : styleClasses2;

  const [keyword, setKeyword] = useState('');
  const [places, setPlaces] = useState([]);
  const [paginationObj, setPaginationObj] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState({
    lat: null,
    lng: null,
    placeName: ""
  });
  const [isKakaoLoaded, setIsKakaoLoaded] = useState(false);

  const mapRef = useRef(null);
  const mapObjRef = useRef(null);
  const psRef = useRef(null);
  const infowindowRef = useRef(null);
  const markersRef = useRef([]);

  useEffect(() => {
    if (window.kakao && window.kakao.maps) {
      initMap();
      setIsKakaoLoaded(true);
      return;
    }
    const script = document.createElement("script");
    script.async = true;
    // 로컬 도메인일 경우 테스트 키 사용
    const isLocalhost = window.location.hostname === "localhost";
    const appKey = isLocalhost
      ? "2bde7fbae9db6f42932855c6a7a59dd4"
      : process.env.REACT_APP_KAKAO_API_KEY;
    // autoload 옵션을 false로 설정하여 수동으로 load 호출
    script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${appKey}&libraries=services&autoload=false`;
    script.onload = () => {
      // SDK의 load 함수를 통해 모든 라이브러리가 준비된 후 initMap 호출
      window.kakao.maps.load(() => {
        initMap();
        setIsKakaoLoaded(true);
        //console.log("Kakao Maps SDK 로드 완료:", window.kakao);
      });
    };
    script.onerror = () => {
      //console.error("Kakao Maps SDK 스크립트 로드 실패");
    };
    document.head.appendChild(script);
    // cleanup: SDK는 한 번 로드되면 계속 유지하므로 제거하지 않습니다.
  }, []);

  const initMap = () => {
    const kakao = window.kakao;
    if (!kakao || !kakao.maps) {
      console.error("initMap: kakao.maps가 undefined입니다.");
      return;
    }
    const container = mapRef.current;
    const options = {
      center: new kakao.maps.LatLng(37.566826, 126.9786567),
      level: 3,
    };
    const map = new kakao.maps.Map(container, options);
    mapObjRef.current = map;

    // Places 서비스와 InfoWindow 초기화
    psRef.current = new kakao.maps.services.Places();
    infowindowRef.current = new kakao.maps.InfoWindow({ zIndex: 1 });

    // 초기 검색 수행
    // searchPlaces();
  };

  const enterKeyword = (event) => {
    if (event.key === 'Enter') {
      searchPlaces(event);
    }
  }

  const searchPlaces = (e) => {
    if (e) e.preventDefault();
    if (!keyword.trim()) {
      setOpenPopup(true);
      setPopupTitle('키워드를 입력해주세요!');
      setPopupButtonText('');
      setCustomFunction('');
      return;
    }
    if (!isKakaoLoaded || !psRef.current) {
      //alert("Kakao Maps API가 아직 준비되지 않았습니다. 잠시 후 다시 시도해주세요.");
      return;
    }
    psRef.current.keywordSearch(keyword, placesSearchCB);
  };

  const placesSearchCB = (data, status, pagination) => {
    const kakao = window.kakao;
    if (status === kakao.maps.services.Status.OK) {
      setPlaces(data);
      setPaginationObj(pagination);
      displayPlaces(data);
    } else if (status === kakao.maps.services.Status.ZERO_RESULT) {
      alert("검색 결과가 존재하지 않습니다.");
    } else if (status === kakao.maps.services.Status.ERROR) {
      alert("검색 결과 중 오류가 발생했습니다.");
    }
  };

  const displayPlaces = (placesData) => {
    const kakao = window.kakao;
    removeMarkers();
    const bounds = new kakao.maps.LatLngBounds();

    placesData.forEach((place, index) => {
      const position = new kakao.maps.LatLng(place.y, place.x);
      bounds.extend(position);
      const marker = addMarker(position, index);
      markersRef.current.push(marker);

      kakao.maps.event.addListener(marker, "click", () => {
        displayInfowindow(marker, place.place_name, position);
      });
    });
    mapObjRef.current.setBounds(bounds);
  };

  const addMarker = (position, idx) => {
    const kakao = window.kakao;
    const imageSrc =
      "https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/marker_number_blue.png";
    const imageSize = new kakao.maps.Size(36, 37);
    const imgOptions = {
      spriteSize: new kakao.maps.Size(36, 691),
      spriteOrigin: new kakao.maps.Point(0, idx * 46 + 10),
      offset: new kakao.maps.Point(13, 37)
    };
    const markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imgOptions);
    const marker = new kakao.maps.Marker({
      position: position,
      image: markerImage
    });
    marker.setMap(mapObjRef.current);
    return marker;
  };

  const removeMarkers = () => {
    markersRef.current.forEach((marker) => marker.setMap(null));
    markersRef.current = [];
  };

  const displayInfowindow = (marker, title, position) => {
    const content = `<div style="padding:5px;z-index:1;">${title}</div>`;
    infowindowRef.current.setContent(content);
    infowindowRef.current.open(mapObjRef.current, marker);
    const lat = position.getLat();
    const lng = position.getLng();
    setSelectedPosition({ lat, lng, placeName: title });
    if (onSelect) {
      onSelect({ lat, lng, placeName: title });
    }
  };

  const handlePageClick = (page) => {
    if (paginationObj) {
      paginationObj.gotoPage(page);
    }
  };

  return (
    <div className={ styleClasses.contactMap }>
      <div className={ styleClasses.mapWrap }>
        <div className={ styleClasses.mapBox } id="map" ref={mapRef} />
        <div className={ styleClasses.mapSearch } id="menu_wrap">
          <div className={ styleClasses.mapOption }>
            <div>
              <input type="text" id="keyword" value={ keyword } placeholder="나의 사업장/스튜디오/활동장소" onChange={(e) => setKeyword(e.target.value)} onKeyDown={ enterKeyword } size="15" />
              <div className="commonButton fullWidth">
                <button type="button" onClick={ searchPlaces }>
                  검색하기
                </button>
              </div>
            </div>
          </div>
          <ul id="placesList" className={ styleClasses.placeList }>
            {places.map((place, index) => (
              <li key={index} className={ styleClasses.placeItem }
                onClick={() => {
                  const kakao = window.kakao;
                  const pos = new kakao.maps.LatLng(place.y, place.x);
                  displayInfowindow(markersRef.current[index], place.place_name, pos);
                }}
              >
                <span className={`markerbg marker_${index + 1} ${ styleClasses.marker }`} />
                <div className={ styleClasses.info }>
                  <h5>{place.place_name}</h5>
                  {place.road_address_name ? (
                    <>
                      <span>{place.road_address_name}</span>
                      <span className={ styleClasses.street }>{place.address_name}</span>
                    </>
                  ) : (
                    <span>{place.address_name}</span>
                  )}
                  <span className={ styleClasses.tel }>{place.phone}</span>
                </div>
              </li>
            ))}
          </ul>
          <div id="pagination" className={ styleClasses.pagination }>
            {paginationObj &&
              Array.from({ length: paginationObj.last }, (_, i) => (
                <a
                  key={i + 1}
                  href="#!"
                  onClick={() => handlePageClick(i + 1)}
                  className={ paginationObj.current === i + 1 ? styleClasses.active : '' }
                >
                  {i + 1}
                </a>
              ))}
          </div>
        </div>
      </div>
      {
        selectedPosition.placeName
        &&
        (
          <div className={ styleClasses.selectedMap }>
            <div className={ styleClasses.eachField }>
              <div className={ styleClasses.fullField }>
                <p>선택된 장소</p>
                <p>{selectedPosition.placeName}</p>
              </div>
            </div>
            <div className={ styleClasses.eachField }>
              <div className={ styleClasses.halfField }>
                <p>위도</p>
                <p>{selectedPosition.lat}</p>
              </div>
              <div className={ styleClasses.halfField }>
                <p>경도</p>
                <p>{selectedPosition.lng}</p>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default KakaoMapSearch;